import React from 'react';
import { withRouter } from 'react-router';
import ChartWarnings from './chartWarnings';
import ChartTimeline from './chartTimeline';
import ChartSubjects from './chartSubjects';
import { withLocalize, Translate } from "react-localize-redux";
import { chartActions } from '../../store/charts/chartsStore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames'

class ChartBottomWindow extends React.Component {
    render() {
        return (
            <div id="bottomWindow" className="bottom-panel" style={{ display: this.props.bottomWindow.expanded ? 'block' : 'none' }}>
                <ul id="bottomWindowHeader" className="nav nav-tabs" style={{ display: 'flex' }}>

                    <li className={classnames("tab", { 'active': this.props.bottomWindow.negInfo.isActive })}
                        style={{ display: this.props.bottomWindow.negInfo.isShowed ? '' : 'none' }} onClick={(e) => this.props.activateBottomWindow(e, 'negInfo')}>
                        <span className="rc-button tab-icon-rc rc-warnings"></span>
                        <a data-toggle="tab" role="tab">
                            <Translate id="Charts.WarningTableSubjectNegInfo" /> <span className="rc-button rc-close" title="" role="button" onClick={(e) => this.props.closeBottomTab(e, 'negInfo')} />
                        </a>
                    </li>
                    <li className={classnames("tab", { 'active': this.props.bottomWindow.timeline.isActive })}
                        style={{ display: this.props.bottomWindow.timeline.isShowed ? '' : 'none' }} onClick={(e) => this.props.activateBottomWindow(e, 'timeline')}>
                        <span className="rc-button tab-icon-rc rc-relations"></span>
                        <a data-toggle="tab" role="tab">
                            <Translate id="Charts.Timeline" /> <span className="rc-button rc-close" title="" role="button" onClick={(e) => this.props.closeBottomTab(e, 'timeline')} />
                        </a>
                    </li>
                    <li className={classnames("tab", { 'active': this.props.bottomWindow.subjects.isActive })}
                        style={{ display: this.props.bottomWindow.subjects.isShowed ? '' : 'none' }} onClick={(e) => this.props.activateBottomWindow(e, 'subjects')}>
                        <span className="rc-button tab-icon-rc rc-subject-list"></span>
                        <a data-toggle="tab" role="tab">
                            <Translate id="Charts.SubjectList" /> <span className="rc-button rc-close" title="" role="button" onClick={(e) => this.props.closeBottomTab(e, 'subjects')} />
                        </a>
                    </li>

                    <li style={{ paddingRight: '11px', marginLeft: 'auto' }}>
                        <a role="button" style={{ float: 'right' }} onClick={this.props.closeBottomWindow}><span className="rc-button control-icon-rc rc-close" title="" /></a>
                        <a role="button" style={{ float: 'right' }} onClick={this.props.maximizeBottomWindow}><span className="rc-button control-icon-rc rc-enlarge-window" title="" /> </a>
                        <a role="button" style={{ float: 'right' }} onClick={this.props.minimizeBottomWindow}><span className="rc-button control-icon-rc rc-reduce-window" title="" /></a>
                    </li>
                </ul>
                <div id="bottomWindowContent" className="tab-content" style={{ height: this.props.bottomWindow.height }}>
                    <div id="negInfo" className="tab-pane" role="tabpanel" style={{ display: this.props.bottomWindow.negInfo.isActive ? 'block' : 'none' }}>
                        <ChartWarnings />
                    </div>
                    <div id="timeline" className="tab-pane" role="tabpanel" style={{ display: this.props.bottomWindow.timeline.isActive ? 'block' : 'none' }}>
                        <ChartTimeline />
                    </div>
                    <div id="subjects" className="tab-pane" role="tabpanel" style={{ display: this.props.bottomWindow.subjects.isActive ? 'block' : 'none' }}>
                        <ChartSubjects />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(chartActions, dispatch)
)(ChartBottomWindow)));
